import React, { memo, useCallback, useMemo } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import useEnergyCompare, { mapMerchantTypeToCompareType, } from 'features/feed/components/save/useEnergyCompare';
import { useAppSelector } from 'store/hooks';
import { selectFeatureFlag } from 'reducers/selectors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectVpnStatus } from 'features/NordVpn/selectors';
import { NordVPNStatusEnum } from 'features/NordVpn/types';
import { isWeb } from '../../../../constants';
const SwitchingButton = ({ onOpenCompare, guessedHomeCountry, data, }) => {
    const compare = useEnergyCompare(onOpenCompare);
    const showEnergySwitch = useAppSelector((store) => selectFeatureFlag(store, 'energy_switch_two').value);
    const navigation = useMainStackNavigation();
    const type = data?.merchantInfo?.type;
    const vpnStatus = useAppSelector(selectVpnStatus);
    const openCompare = useCallback(async () => {
        if (type === 'NORD_VPN' || type === 'VPN') {
            navigation.navigate('ManageNordVpn');
            return;
        }
        if (type === 'GAS_AND_ELECTRICITY' || type === 'BROADBAND') {
            compare(mapMerchantTypeToCompareType(type));
        }
    }, [compare, type]);
    const label = useMemo(() => {
        if (type === 'NORD_VPN' && vpnStatus !== NordVPNStatusEnum.ACTIVE) {
            return 'Get it for free';
        }
        if (type === 'VPN' && vpnStatus !== NordVPNStatusEnum.ACTIVE) {
            return 'Get a free VPN';
        }
        if (guessedHomeCountry === 'GB') {
            if (showEnergySwitch && type === 'GAS_AND_ELECTRICITY') {
                return 'Save on energy';
            }
            if (type === 'BROADBAND')
                return 'Save on broadband';
        }
        return null;
    }, [guessedHomeCountry, showEnergySwitch, type, vpnStatus]);
    if (!label || isWeb)
        return null;
    return (<TouchableOpacity style={styles.button} onPress={openCompare}>
      <View style={styles.container}>
        <Text TextThin-14 Primary>
          {label}
        </Text>
      </View>
    </TouchableOpacity>);
};
const styles = StyleSheet.create({
    button: {
        marginTop: rem(2),
        alignSelf: 'flex-start',
    },
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});
export default memo(SwitchingButton);
